import { Component, OnInit } from '@angular/core';
import { ColorClass } from 'shared';

@Component({
    selector: 'app-calculated-price-info-modal',
    templateUrl: './calculated-price-info-modal.component.html',
    styleUrls: ['./calculated-price-info-modal.component.scss'],
})
export class CalculatedPriceInfoModalComponent implements OnInit {

    public ColorClass = ColorClass;

    constructor() {}

    ngOnInit(): void {}
}
